import { RegistrationState } from '../registration.interface';
import { RequestType } from '../../../model/enums/RequestType';
import { RegistrationValidation } from '../../../model/RegistrationValidation';

interface RequiredField {
  key: string,
  label: string
}

const getRegistrationRequiredFields = (requestType: RequestType): RequiredField[] => {
  return [
    {
      key: 'clinic',
      label: 'kliniku'
    },
    {
      key: 'goal',
      label: requestType === RequestType.PatientRegistration ? 'cíl návštěvy' : 'cíl předání pacienta'
    }
  ];
};

const getPatientRequiredFields = (patientHasPersonalNumber: boolean): RequiredField[] => {
  const requiredFields = [
    {
      key: 'firstName',
      label: 'jméno pacienta'
    },
    {
      key: 'lastName',
      label: 'příjmení pacienta'
    },
    {
      key: 'phone',
      label: 'telefonní číslo pacienta'
    }
  ];

  if (patientHasPersonalNumber) {
    requiredFields.push(...[
      {
        key: 'insuranceCompany',
        label: 'zdravotní pojišťovnu pacienta'
      },
      {
        key: 'personalNumber',
        label: 'rodné číslo pacienta'
      }
    ]);
  } else {
    requiredFields.push({
      key: 'insuranceNumber',
      label: 'číslo pojištěnce pacienta'
    });
  }

  return requiredFields;
};

const getDoctorRequiredFields = (requestType: RequestType): RequiredField[] => {
  if (requestType !== RequestType.DoctorRegistration) {
    return [];
  }

  return [
    {
      key: 'firstName',
      label: 'jméno lékaře'
    },
    {
      key: 'lastName',
      label: 'příjmení lékaře'
    },
    {
      key: 'phone',
      label: 'telefonní číslo lékaře'
    }
  ];
};

export const getMissingFields = (registration: RegistrationState, requestType: RequestType): string[] => {
  const requiredRegistrationFields = getRegistrationRequiredFields(requestType);
  const missingRegistrationFields = requiredRegistrationFields.filter(field => !registration[field.key]);

  const requiredPatientFields = getPatientRequiredFields(registration.patient.hasPersonalNumber);
  const missingPatientFields = requiredPatientFields.filter(field => !registration.patient[field.key]);

  const requiredDoctorFields = getDoctorRequiredFields(requestType);
  const missingDoctorFields = requiredDoctorFields.filter(field => !registration.doctor[field.key]);

  return [...missingRegistrationFields, ...missingPatientFields, ...missingDoctorFields].map(field => field.label);
};

export const validateRegistration = (registration: RegistrationState, requestType: RequestType, validation: RegistrationValidation): boolean => {
  return !getMissingFields(registration, requestType).length && !getInvalidFields(validation).length;
};

export const getInvalidFields = (validation: RegistrationValidation): string[] => {
  let invalidFields: string[] = [];

  if (!validation.patient.email) {
    invalidFields.push('e-mail pacienta');
  }

  if (!validation.doctor.email) {
    invalidFields.push('e-mail lékaře');
  }

  if (!validation.patient.phone) {
    invalidFields.push('telefonní číslo pacienta');
  }

  if (!validation.doctor.phone) {
    invalidFields.push('telefonní číslo lékaře');
  }

  return invalidFields;
};
